import moment from "moment";

export const convertSecondsToMinutes = seconds => {
  const durationInSeconds = moment.duration(seconds, "seconds");
  const durationInMinutes = durationInSeconds.minutes();
  return durationInMinutes;
};
